module.exports = "<div echarts [options]=\"option\" class=\"echart\" (chartInit)=\"onChartInit($event)\"></div>"